<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- name -->
      <div class="columns">
        <div class="column has-text-centered"><label>Ime:</label></div>
        <div class="column is-four-fifths">
          <input
            class="input is-small has-text-centered has-background-info-light"
            type="text"
            v-model="selectedRoute.name"
          />
        </div>
      </div>
      <!-- description -->
      <div class="columns">
        <div class="column has-text-centered"><label>opis:</label></div>
        <div class="column is-four-fifths">
          <input
            class="input is-small has-text-centered has-background-info-light"
            type="text"
            v-model="selectedRoute.description"
          />
        </div>
      </div>
      <!-- value -->
      <div class="columns">
        <div class="column has-text-centered"><label>Vrijednost:</label></div>
        <div class="column is-four-fifths">
          <input
            class="input is-small has-text-centered has-background-info-light"
            type="text"
            v-model="selectedRoute.value"
          />
        </div>
      </div>
      <!-- text -->
      <div class="columns">
        <div class="column has-text-centered"><label>Broj kartice:</label></div>
        <div class="column is-four-fifths">
          <input
            class="input is-small has-text-centered has-background-info-light"
            type="text"
            v-model="selectedRoute.text"
          />
        </div>
      </div>
      <!-- Buttons -->
      <div class="columns">
        <div v-show="isSaveAndProceedButtonVisible" class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndProceedButtonClicked"
          >
            SAČUVAJ I NASTAVI
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndCloseButtonClicked"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditCard",

  props: {
    title: String,
    selectedRoute: Object,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {};
  },
  methods: {
    saveAndProceedButtonClicked() {
      this.$emit("saveAndProceedButtonClicked", this.selectedRoute);
    },
    saveAndCloseButtonClicked() {
      this.$emit("saveAndCloseButtonClicked", this.selectedRoute);
    },
  },
};
</script>